import { render } from "./AbnormalChatList.vue?vue&type=template&id=d4923308"
import script from "./AbnormalChatList.vue?vue&type=script&lang=js"
export * from "./AbnormalChatList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__